import(/* webpackMode: "eager" */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\not-found.tsx");
